// extracted by mini-css-extract-plugin
export default {"root":"styles_root__QCKtQ","dragging-over":"styles_dragging-over__bP6jO","draggingOver":"styles_dragging-over__bP6jO","color":"styles_color__CHcmM"};